import { renderTurboStream } from "@/helpers/turbo"

const FETCH_TIMEOUT = 5000

const abortController = new window.AbortController()

const fetchRecentLocations = (): void => {
  // Abort any in-progress fetch when page begins unloading to avoid
  // `TypeError: Load failed` errors in iOS.
  document.addEventListener("pagehide", () => abortController.abort(), { once: true })

  // Return if fetch can be made, otherwise re-try the first time page becomes visible.
  if (fetchIfVisible()) {
    return
  } else {
    document.addEventListener("visibilitychange", fetchIfVisible, { once: true })
  }
}

const fetchIfVisible = (): boolean => {
  const { AbortSignal } = window
  // `any` and `timeout` undefined in iOS < 17.4 and < 16 respectively (neither of which
  // we support but still get errors from).
  const isModernAbortSignal =
    typeof AbortSignal.any !== "undefined" && typeof AbortSignal.timeout !== "undefined"

  if (document.visibilityState === "visible") {
    void renderTurboStream("/recent_locations", {
      signal: isModernAbortSignal
        ? AbortSignal.any([AbortSignal.timeout(FETCH_TIMEOUT), abortController.signal])
        : abortController.signal
    })
    return true
  } else {
    return false
  }
}

export { fetchRecentLocations }
